// Hidden SVG with color-matrix filter that removes black background from the PNG logo.
// The filter keys out pure black pixels (and very dark shadows) making them transparent.
export default function LogoFilter() {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: "absolute", width: 0, height: 0 }}
      aria-hidden="true"
    >
      <defs>
        <filter id="remove-black" colorInterpolationFilters="sRGB">
          {/* Build alpha from luminance: dark → transparent, light (blue logo) → opaque */}
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0
                    0 1 0 0 0
                    0 0 1 0 0
                    4 4 4 0 0"
          />
        </filter>
      </defs>
    </svg>
  );
}
